import { isFRQ } from '../progressHelpers';
/**
 * Checks if questions are only MCQs
 * @param {array} questions The list of questions
 * @returns {boolean}
 * */
const areMcqQuestions = (questions) =>
  !(questions || []).some((question) => isFRQ(question));

export default areMcqQuestions;
